import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PipelineVariablesEditorOptions } from '@selfai-platform/pipeline-common';
import { DialogService } from '@selfai-platform/shell';
import { Observable } from 'rxjs';
import { PipelineVariablesEditorComponent } from '../../variables-editor';

@Injectable()
export class PipelineVariablesService {
  constructor(
    private readonly dialogService: DialogService<never, PipelineVariablesEditorOptions>,
    private readonly translateService: TranslateService,
  ) {}

  public showEditor(data: PipelineVariablesEditorOptions): Observable<void> {
    return this.dialogService.showDialog(PipelineVariablesEditorComponent, {
      header: this.translateService.instant('workflow.variables.tree.header'),
      width: '75%',
      height: '90vh',
      data: data,
      closeOnEscape: false,
      maximizable: true,
    });
  }
}
